"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2014-2017 Flowhub UG
//     NoFlo may be freely distributed under the MIT license
var _require = require('events'),
    EventEmitter = _require.EventEmitter; // ## NoFlo Port Base class
//
// Base port type used for options normalization. Both inports and outports extend this class.
// The list of valid datatypes for ports.


var validTypes = ['all', 'string', 'number', 'int', 'object', 'array', 'boolean', 'color', 'date', 'bang', 'function', 'buffer', 'stream'];

function handleOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // We default to the `all` type if no explicit datatype
  // was provided
  var datatype = options.datatype || 'all'; // Normalize the legacy `integer` type to `int`.

  if (datatype === 'integer') {
    datatype = 'int';
  } // By default ports are not required for graph execution


  var required = options.required || false; // Ensure datatype defined for the port is valid

  if (validTypes.indexOf(datatype) === -1) {
    throw new Error("Invalid port datatype '".concat(datatype, "' specified, valid are ").concat(validTypes.join(', ')));
  } // Ensure schema defined for the port is valid


  var schema = options.schema || options.type;

  if (schema && schema.indexOf('/') === -1) {
    throw new Error("Invalid port schema '".concat(schema, "' specified. Should be URL or MIME type"));
  }
  /* eslint-disable prefer-object-spread */


  return Object.assign({}, options, {
    datatype: datatype,
    required: required,
    schema: schema
  });
}

module.exports = /*#__PURE__*/function (_EventEmitter) {
  _inherits(BasePort, _EventEmitter);

  var _super = _createSuper(BasePort);

  function BasePort(options) {
    var _this;

    _classCallCheck(this, BasePort);

    _this = _super.call(this); // Options holds all options of the current port

    _this.options = handleOptions(options); // Sockets list contains all currently attached
    // connections to the port

    _this.sockets = []; // Name of the graph node this port is in

    _this.node = null; // Name of the port

    _this.name = null;
    return _this;
  }

  _createClass(BasePort, [{
    key: "getId",
    value: function getId() {
      if (!this.node || !this.name) {
        return 'Port';
      }

      return "".concat(this.node, " ").concat(this.name.toUpperCase());
    }
  }, {
    key: "getDataType",
    value: function getDataType() {
      return this.options.datatype;
    }
  }, {
    key: "getSchema",
    value: function getSchema() {
      return this.options.schema || null;
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      return this.options.description;
    }
  }, {
    key: "attach",
    value: function attach(socket) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var idx = index;

      if (!this.isAddressable() || index === null) {
        idx = this.sockets.length;
      }

      this.sockets[idx] = socket;
      this.attachSocket(socket, idx);

      if (this.isAddressable()) {
        this.emit('attach', socket, idx);
        return;
      }

      this.emit('attach', socket);
    }
    /* eslint-disable class-methods-use-this */

  }, {
    key: "attachSocket",
    value: function attachSocket() {}
  }, {
    key: "detach",
    value: function detach(socket) {
      var index = this.sockets.indexOf(socket);

      if (index === -1) {
        return;
      }

      this.sockets[index] = undefined;

      if (this.isAddressable()) {
        this.emit('detach', socket, index);
        return;
      }

      this.emit('detach', socket);
    }
  }, {
    key: "isAddressable",
    value: function isAddressable() {
      if (this.options.addressable) {
        return true;
      }

      return false;
    }
  }, {
    key: "isBuffered",
    value: function isBuffered() {
      if (this.options.buffered) {
        return true;
      }

      return false;
    }
  }, {
    key: "isRequired",
    value: function isRequired() {
      if (this.options.required) {
        return true;
      }

      return false;
    }
  }, {
    key: "isAttached",
    value: function isAttached() {
      var socketId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.isAddressable() && socketId !== null) {
        if (this.sockets[socketId]) {
          return true;
        }

        return false;
      }

      if (this.sockets.length) {
        return true;
      }

      return false;
    }
  }, {
    key: "listAttached",
    value: function listAttached() {
      var attached = [];

      for (var idx = 0; idx < this.sockets.length; idx += 1) {
        var socket = this.sockets[idx];

        if (socket) {
          attached.push(idx);
        }
      }

      return attached;
    }
  }, {
    key: "isConnected",
    value: function isConnected() {
      var socketId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.isAddressable()) {
        if (socketId === null) {
          throw new Error("".concat(this.getId(), ": Socket ID required"));
        }

        if (!this.sockets[socketId]) {
          throw new Error("".concat(this.getId(), ": Socket ").concat(socketId, " not available"));
        }

        return this.sockets[socketId].isConnected();
      }

      var connected = false;
      this.sockets.forEach(function (socket) {
        if (!socket) {
          return;
        }

        if (socket.isConnected()) {
          connected = true;
        }
      });
      return connected;
    }
    /* eslint-disable class-methods-use-this */

  }, {
    key: "canAttach",
    value: function canAttach() {
      return true;
    }
  }]);

  return BasePort;
}(EventEmitter);